<template>
  <div>
    <ValueComparison
      :value="selectReportValue(widgetId)"
      :comparison="selectComparisonPercent(widgetId)"
      v-if="!loading"
    />
    <ValueComparisonLoader v-else />
    <AreaGraph
      :dataSet="selectTrendData('completedSurveyCount')"
      :valueType="'integer'"
      v-if="!!selectTrendData('completedSurveyCount')"
      :granularity="selectGranularity"
    />
  </div>
</template>

<script>
import ValueComparison from '@/components/Modules/Dashboard/Widget/ReportTypes/ValueComparison'
import ValueComparisonLoader from '@/components/Modules/Dashboard/Widget/SkeletonLoaders/ValueComparisonLoader'
import AreaGraph from '@/components/Modules/Dashboard/Widget/ReportTypes/AreaGraph'
import { createNamespacedHelpers } from 'vuex'

const DashboardModule = createNamespacedHelpers('dashboard')

export default {
  name: 'SurveyCompletedCount',
  props: ['widgetId'],
  components: {
    ValueComparison,
    ValueComparisonLoader,
    AreaGraph
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...DashboardModule.mapGetters([
      'selectComparisonPercent',
      'selectReportValue',
      'selectTrendData',
      'selectGranularity'
    ])
  },
  methods: {
    ...DashboardModule.mapActions(['fetchSurveyCompletedCount'])
  },
  async mounted() {
    await this.fetchSurveyCompletedCount({ widgetId: this.widgetId })
    this.loading = false
  }
}
</script>
